import {
    Link, TextField
} from '@mui/material';
import React from 'react';
import { Search, Close } from '@mui/icons-material';
const NestedSearch = (props) => {
    const [showIcon, setShowIcon] = React.useState(true);
    const [value, setValue] = React.useState();

    /**
     * handle search bar click
     * 
     */
    const handelClick = () => {
        if (!showIcon) {
            props.search('');
            setValue('');
        }
        setShowIcon(!showIcon)

    }

    /**
     * Pass value to parent
     * @param {*} event 
     */
    const filterResults = (event) => {
        setValue(event.target.value);
        props.search(event.target.value)
    }
    return (
        <div>
            {
                showIcon &&
                <Link to="#" className='d-flex px-3 justify-content-end' onClick={handelClick}>
                    <Search className='pointer ' />
                </Link>
            }
            {
                !showIcon &&
                <div className='row px-3 '>
                    < TextField
                        type='text'
                        onChange={filterResults}
                        key={'search'}
                        value={(value || '')}
                        id={'filterNested'}
                        name={'Filter'}
                        variant="standard"
                        placeholder={'Search ' + props.label}
                        color="primary" className="col-10 _wg-dynamic-text" autoFocus={true} />
                    <Link to="#" className='d-flex justify-content-end col-2' onClick={handelClick}>
                        <Close className='pointer ' />
                    </Link>
                </div>
            }
        </div>
    )
}

export default NestedSearch;